import { render, staticRenderFns } from "./AdditionalSalesView.vue?vue&type=template&id=16acfe2b&scoped=true"
import script from "./AdditionalSalesView.vue?vue&type=script&lang=js"
export * from "./AdditionalSalesView.vue?vue&type=script&lang=js"
import style0 from "./AdditionalSalesView.vue?vue&type=style&index=0&id=16acfe2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.26_css-loader@6.11.0_webpack@5.104.1__lodash@4_6a4e8631f36538c7428b4f6a46ee29d3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16acfe2b",
  null
  
)

export default component.exports